






































































































import VueApexCharts from "vue-apexcharts";
import { Vue, Component, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import {
  CategoryChartData,
  CategoryChartSeries
} from "../../models/category-chart-data";
import { InvoiceListEntry } from "../../models/invoice-list-entry";
import { invoiceAnalyticsService } from "../../services/analytics.service";
import AnalyticsStore from "../../store/analytics.store";
import AnalyticsInvoiceItem from "../data/AnalyticsInvoiceItem.vue";
import InvoiceListTable from "../data/InvoiceListTable.vue";
import VueSlider from "vue-slider-component";
import "@/design/external-libraries/_vue-slider-theme.scss";

@Component({
  components: {
    apexchart: VueApexCharts,
    "vue-slider": VueSlider,
    "invoice-list-table": InvoiceListTable,
    "invoice-item": AnalyticsInvoiceItem
  }
})
export default class SupplierHeaderFieldRecogChart extends Vue {
  private loadingInvoiceList = false;
  private loadingSupplierRecogData = false;
  private loadingFieldRecogData = false;
  private selectedField = "";
  private accuracyRangeValue = [0, 100];
  private selectedSupplier = "";
  private selectedSupplierNameRange = ["A", "Z"];
  private supplierNameRange = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
  ];

  private readonly analyticsStore: AnalyticsStore = getModule(
    AnalyticsStore,
    this.$store
  );
  get recogByHeaderFieldData() {
    return this.analyticsStore.getRecogByHeaderFieldData;
  }
  get dateRange() {
    return this.analyticsStore.getDateRange;
  }
  get selectedSite() {
    return this.analyticsStore.getSelectedSite;
  }
  get searchButtonClicked() {
    return this.analyticsStore.getSearchButtonClicked;
  }
  get selectedInvoice() {
    return this.analyticsStore.getSelectedInvoice;
  }
  get selectedInvoicePdfLocation() {
    return this.analyticsStore.getSelectedInvoicePdfLocation;
  }
  private series: CategoryChartSeries[] = [];
  private supplierRecogSeries: CategoryChartSeries[] = [];
  private supplierRecogData: CategoryChartData[] = [];
  private invoiceList: InvoiceListEntry[] = [];

  private chartOptions = {
    chart: {
      id: "allSuppliersAverageRecogByField",
      fontFamily: "'Lato', sans-serif",
      toolbar: {
        export: {
          csv: {
            filename: `header-field-recognition-${this.dateRange.startDate}-to-${this.dateRange.endDate}`,
            columnDelimiter: ",",
            headerCategory: "Field"
          }
        }
      },
      events: {
        dataPointSelection: async (e: any, chart: any, opts: any) => {
          const recogByField = document.querySelector(
            "#recog-by-field-all-suppliers"
          );
          const supplierRecogForField = document.querySelector(
            "#supplier-recog-for-selected-field"
          );

          if (opts.selectedDataPoints[0]) {
            if (
              opts.selectedDataPoints[0].length === 1 &&
              supplierRecogForField != null &&
              supplierRecogForField.classList.contains("active")
            ) {
              this.updateSupplierRecogChart(chart, "supplierRecogForField");
            } else if (
              opts.selectedDataPoints[0].length === 1 &&
              supplierRecogForField != null &&
              recogByField != null
            ) {
              recogByField.classList.add("supplier-recog-chart-activated");
              supplierRecogForField.classList.add("active");
              this.updateSupplierRecogChart(chart, "supplierRecogForField");
            }
          }

          if (
            recogByField != null &&
            supplierRecogForField != null &&
            opts.selectedDataPoints[0]
          ) {
            if (opts.selectedDataPoints[0].length === 0) {
              recogByField.classList.remove("header-recog-chart-activated");
              supplierRecogForField.classList.remove("active");
            }
          }
        }
      }
    },
    dataLabels: {
      enabled: true
    },
    states: {
      normal: {
        filter: {
          type: "desaturate"
        }
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: "darken",
          value: 0.25
        }
      }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true
      }
    },
    yaxis: {
      title: {
        text: "Field"
      },
      min: 0,
      max: 100
    },
    xaxis: {
      type: "category",
      title: {
        text: "Recognition Rate (%)"
      }
    },
    title: {
      text: "Recognition Rate by Field",
      align: "left"
    },
    subtitle: {
      text: "Average across all suppliers for selected date range",
      align: "left"
    },
    colors: [
      "#07445b",
      "#49547b",
      "#77677a",
      "#bf9856",
      "#e28b44",
      "#d46b4f",
      "#bb5055",
      "#9e3a58",
      "#7c285a"
    ],
    legend: {
      show: false
    },
    tooltip: {
      y: {
        formatter: function(value: any) {
          if (value) {
            return value.toString().concat("%");
          }
        }
      }
    },
    noData: {
      text: "No data for selected options",
      align: "center"
    }
  };

  private supplierRecogChartOptions = {
    chart: {
      id: "supplierRecogForField",
      type: "bar",
      fontFamily: "'Lato', sans-serif",
      toolbar: {
        export: {
          csv: {
            filename: `supplier-recog-${this.selectedField}-${this.dateRange.startDate}-to-${this.dateRange.endDate}`,
            columnDelimiter: ",",
            headerCategory: "Supplier ID"
          }
        }
      },
      events: {
        dataPointSelection: async (e: any, chart: any, opts: any) => {
          const supplierRecogForField = document.querySelector(
            "#supplier-recog-for-selected-field"
          );

          if (opts.selectedDataPoints[0]) {
            if (
              opts.selectedDataPoints[0].length === 1 &&
              supplierRecogForField != null &&
              supplierRecogForField.classList.contains("active")
            ) {
              await this.updateInvoiceList(chart);
            }
          }

          if (supplierRecogForField != null && opts.selectedDataPoints[0]) {
            if (opts.selectedDataPoints[0].length === 0) {
              supplierRecogForField.classList.remove("active");
            }
          }
        },
        click: async (e: any, chart: any, opts: any) => {
          await this.updateInvoiceListForClickOnZeroValue(chart, opts);
        }
      }
    },
    dataLabels: {
      enabled: false
    },
    title: {
      text: "Recognition Rate by Supplier by Field",
      align: "left"
    },
    subtitle: {
      text: "Selected Field",
      align: "left"
    },
    yaxis: {
      title: {
        text: "Recognition Rate (%)"
      },
      min: 0,
      max: 100
    },
    xaxis: {
      type: "category",
      title: {
        text: "Supplier ID"
      },
      labels: {
        formatter: (value: any) => {
          if (value.length) {
            const supplierIdIndex = value.lastIndexOf("/");
            const supplierId = value.substring(supplierIdIndex + 1);
            return supplierId;
          }
        }
      }
    },
    colors: ["#07445b"],
    legend: {
      show: false
    },
    tooltip: {
      shared: true,
      intersect: false,
      x: {
        formatter: function(value: any) {
          if (value.length) {
            const supplierIdIndex = value.lastIndexOf("/");
            return value
              .substring(0, supplierIdIndex - 1)
              .concat(` (${value.substring(supplierIdIndex + 1)})`);
          }
        }
      },
      y: {
        formatter: function(value: any) {
          if (value) {
            return value.toString().concat("%");
          }
        }
      }
    },
    noData: {
      text: "No data for selected options",
      align: "center"
    }
  };

  async created() {
    if (this.recogByHeaderFieldData.length === 0) {
      await this.fetchNewChartData();
    }
    this.updateChart();
  }

  async fetchNewChartData() {
    // clear field, supplier, and invoice selections
    this.selectedField = "";
    this.selectedSupplier = "";
    this.analyticsStore.updateSelectedInvoice(null);

    // hide supplier recognition chart
    const supplierRecogForField = document.querySelector(
      "#supplier-recog-for-selected-field"
    );
    if (supplierRecogForField != null) {
      supplierRecogForField.classList.remove("active");
    }

    if (this.selectedSite !== "") {
      this.loadingFieldRecogData = true;
      const chartData: CategoryChartData[] = await invoiceAnalyticsService.loadRecogByHeaderDataAsync(
        this.selectedSite,
        this.dateRange.startDate,
        this.dateRange.endDate,
        "",
        "",
        true // default include validation services in recog rates for this page
      );
      this.analyticsStore.updateRecogByHeaderFieldData(chartData);
      this.loadingFieldRecogData = false;
    } else {
      this.analyticsStore.updateRecogByHeaderFieldData([]);
    }
  }

  updateChart() {
    this.series = [
      {
        name: "Recognition rate",
        data: this.recogByHeaderFieldData
      }
    ];
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async updateSupplierRecogChart(sourceChart: any, destChartIDToUpdate: any) {
    // clear supplier and invoice selections
    this.analyticsStore.updateSelectedInvoice(null);
    this.selectedSupplier = "";

    if (sourceChart.w.globals.selectedDataPoints[0]) {
      if (this.selectedSite !== "") {
        this.loadingSupplierRecogData = true;
        this.accuracyRangeValue = [0, 100];
        this.selectedSupplierNameRange = ["A", "Z"];
        this.selectedField =
          sourceChart.w.globals.labels[
            sourceChart.w.globals.selectedDataPoints[0][0]
          ];

        const supplierRecogData = await invoiceAnalyticsService.loadSupplierRecogByFieldDataAsync(
          this.selectedSite,
          this.dateRange.startDate,
          this.dateRange.endDate,
          this.selectedField
        );

        this.supplierRecogData = await supplierRecogData;

        this.supplierRecogSeries = [
          {
            name: "Recognition rate",
            data: await supplierRecogData
          }
        ];

        this.supplierRecogChartOptions = {
          ...this.supplierRecogChartOptions,
          subtitle: {
            text: `${this.selectedField} for selected date range`,
            align: "left"
          }
        };

        this.loadingSupplierRecogData = false;
      }
    }
  }

  updateSupplierRecogDataDisplayed() {
    // deselect any selected supplier or invoice when user filters suppliers
    this.selectedSupplier = "";
    this.analyticsStore.updateSelectedInvoice(null);

    // find suppliers whose names start with a letter in the selected range
    const supplierNameMatches: CategoryChartData[] = [];
    const startLetterIndex = this.supplierNameRange.indexOf(
      this.selectedSupplierNameRange[0]
    );
    const stopLetterIndex = this.supplierNameRange.indexOf(
      this.selectedSupplierNameRange[1]
    );
    for (let i = startLetterIndex; i <= stopLetterIndex; i++) {
      this.supplierRecogData.forEach((obj: CategoryChartData) => {
        if (obj.x.startsWith(this.supplierNameRange[i])) {
          supplierNameMatches.push(obj);
        }
      });
    }
    // filter data to suppliers in name and accuracy range selected
    const filteredSupplierData = this.supplierRecogData.filter(
      (obj: CategoryChartData) =>
        obj.y >= this.accuracyRangeValue[0] &&
        obj.y <= this.accuracyRangeValue[1] &&
        supplierNameMatches.includes(obj)
    );
    this.supplierRecogSeries = [
      {
        name: "Recognition rate",
        data: filteredSupplierData
      }
    ];
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async updateInvoiceList(sourceChart: any) {
    this.analyticsStore.updateSelectedInvoice(null);

    if (sourceChart.w.globals.selectedDataPoints[0]) {
      if (this.selectedSite !== "") {
        this.loadingInvoiceList = true;
        this.selectedSupplier =
          sourceChart.w.globals.labels[
            sourceChart.w.globals.selectedDataPoints[0][0]
          ];

        const supplierIdIndex = this.selectedSupplier.lastIndexOf("/");
        const selectedSupplierId = this.selectedSupplier.substring(
          supplierIdIndex + 1
        );

        this.invoiceList = await invoiceAnalyticsService.loadInvoiceListAnalyticsAsync(
          this.selectedSite,
          this.dateRange.startDate,
          this.dateRange.endDate,
          "supplierid",
          selectedSupplierId
        );

        this.loadingInvoiceList = false;
      }
    }
  }

  async updateInvoiceListForClickOnZeroValue(sourceChart: any, options: any) {
    // unselected any selected invoice
    this.analyticsStore.updateSelectedInvoice(null);
    this.loadingInvoiceList = true;
    // find clicked data point's index in chart series data
    const selectedDataPoint = options.dataPointIndex;
    // obtain name and supplier ID from x-axis value of selectedDataPoint
    if (this.supplierRecogSeries[0].data[selectedDataPoint]) {
      this.selectedSupplier = this.supplierRecogSeries[0].data[
        selectedDataPoint
      ].x;

      // isolate supplier ID
      const supplierIdIndex = this.selectedSupplier.lastIndexOf("/");
      const selectedSupplierId = this.selectedSupplier.substring(
        supplierIdIndex + 1
      );
      // update list of invoices displayed
      this.invoiceList = await invoiceAnalyticsService.loadInvoiceListAnalyticsAsync(
        this.selectedSite,
        this.dateRange.startDate,
        this.dateRange.endDate,
        "supplierid",
        selectedSupplierId
      );
    }

    this.loadingInvoiceList = false;
  }

  @Watch("searchButtonClicked")
  async updateSearch() {
    await this.fetchNewChartData();
    this.updateChart();
    this.$emit("chartLoaded");
  }
}
